jQuery(document).ready(function ($) {

    jQuery('select:not(.gfield_select)').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    });

    var scrollPosition = jQuery(window).scrollTop();
    var header = jQuery('.site_sticky_header'); // Use your header's ID

    if (scrollPosition > 0) {
        header.addClass('scrolled_header');
    } else {
        header.removeClass('scrolled_header');
    }

    var lochash = window.location.hash;
    if (lochash != "" && lochash != undefined && lochash != null) {
        if (jQuery(".tabbing_section .tabs_section .tabs .tab[data-pid='" + lochash + "']").length > 0) {
            jQuery(".tabbing_section .tabs_section .tabs .tab").removeClass("active");
            jQuery(".tabbing_section .tab_content .tab_content_item").removeClass("active");
            jQuery(".tabbing_section .tabs_section .tabs .tab[data-pid='" + lochash + "']").addClass("active");
            jQuery(".tabbing_section .tab_content .tab_content_item[data-content-id='" + lochash + "']").addClass("active");
        }
    }
    jQuery(".hero_banner_slider_section").each(function () {
        var $hero_banner_slider_section = jQuery(this);
        var $hero_background_video_image_slider = $hero_banner_slider_section.find(".hero_background_image_slider");
        var $hero_background_video_image_slide = $hero_background_video_image_slider.find(".hero_background_image_slider_item");
        var $mini_bottom_slider = $hero_banner_slider_section.find(".hero_slider_content_part .mini_bottom_slider");
        var $mini_bottom_slide = $mini_bottom_slider.find(".mini_bottom_slider_item");

        $mini_bottom_slider.on('init', function (event, slick) {
            var totalSlides = slick.slideCount;
            var currentSlide = slick.currentSlide || 0;

            var realIndex = currentSlide % totalSlides;

            $mini_bottom_slider.find('.slick-slide').removeClass('current-slide next-slide prev-slide');

            var nextIndex = (realIndex + 1) % totalSlides;
            var prevIndex = (realIndex - 1 + totalSlides) % totalSlides;

            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${realIndex}"]`).addClass('current-slide');
            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${nextIndex}"]`).addClass('next-slide');
            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${prevIndex}"]`).addClass('prev-slide');
        });
        $hero_background_video_image_slider.on('init', function (event, slick) {
            var totalSlides = slick.slideCount;
            var currentSlide = slick.currentSlide || 0;

            var realIndex = currentSlide % totalSlides;
            if (realIndex < 0) realIndex += totalSlides;

            var percent = ((realIndex + 1) / totalSlides) * 100;
            $('.hero_slider_dots_control .progress-line').css('width', `${percent}%`);

        });
        if ($mini_bottom_slide.length > 1) {
            $mini_bottom_slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                arrows: false,
                initialSlide: 1,
                fade: true,
                speed: 500,
                cssEase: 'linear',
                arrows: false,
                draggable: false,
                swipe: false,
                dots: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplaySpeed: 5000,
                // variablewidth:true,
                // asNavFor: $hero_background_video_image_slider,
            });
        }
        if ($hero_background_video_image_slide.length > 1) {

            $hero_background_video_image_slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                arrows: false,
                fade: true,
                dots: false,
                autoplaySpeed: 5000,
                speed: 500,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
                // draggable: false,
                // swipe: false,
                // asNavFor: $mini_bottom_slider,
                // responsive: [{
                //     breakpoint: 768,
                //     settings: {

                //     }
                // }, ]
            });
        }
        if ($hero_background_video_image_slide.length <= 1) {
            $mini_bottom_slider.hide();
            $('.hero_slider_dots_control .progress-line').hide();
        }

        $mini_bottom_slider.on('click', '.slick-slide', function (event) {
            var index = $(this).data('slick-index');
            var currentSlide = $hero_background_video_image_slider.slick('slickCurrentSlide');

            if (index !== currentSlide) {
                $hero_background_video_image_slider.slick('slickGoTo', index);
                $mini_bottom_slider.slick('slickGoTo', index);
            }

            $mini_bottom_slider.slick('slickNext');
            $mini_bottom_slider.slick('slickPlay');
        });
        $hero_background_video_image_slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var totalSlides = slick.slideCount;
            var realIndex = nextSlide % totalSlides;
            if (realIndex < 0) realIndex += totalSlides;

            var percent = ((realIndex + 1) / totalSlides) * 100;
            $('.hero_slider_dots_control .progress-line').css('width', `${percent}%`);
        });

        $mini_bottom_slider.on('afterChange', function (event, slick, currentSlide) {
            var totalSlides = slick.slideCount;

            var realIndex = currentSlide % totalSlides;
            if (realIndex < 0) realIndex += totalSlides;


            $mini_bottom_slider.find('.slick-slide').removeClass('current-slide next-slide prev-slide');

            var nextIndex = (realIndex + 1) % totalSlides;
            var prevIndex = (realIndex - 1 + totalSlides) % totalSlides;

            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${realIndex}"]`).addClass('current-slide');
            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${nextIndex}"]`).addClass('next-slide');
            $mini_bottom_slider.find(`.slick-slide[data-slick-index="${prevIndex}"]`).addClass('prev-slide');
        });

    });

    // $(".heading_tabs").each(function (index) {
    // var secId = jQuery(this).attr("id");
    // const tabsElem = "#" + secId + " .tab";
    // const tabsContentElem = "#" + secId + " .tab_content_item";
    // const tabs = document.querySelectorAll(tabsElem);
    // const tabContents = document.querySelectorAll(tabsContentElem);
    // tabs.forEach(tab => {
    //     tab.addEventListener('click', function () {
    //         tabs.forEach(tab => tab.classList.remove('active'));
    //         tabContents.forEach(content => content.classList.remove('active'));
    //         this.classList.add('active');
    //         document.getElementById(this.dataset.tabContent).classList.add('active');
    //     });
    // });

    // });
    jQuery(".heading_tabs_wrapper_list .tab").click(function () {
        var tabContent = jQuery(this).attr("data-tab-content");
        jQuery(this).closest(".tabs").find(".tab").removeClass("active");
        jQuery(this).closest(".heading_tabs_wrapper_list").find(".tab_content_item").removeClass("active");
        jQuery(this).addClass("active");
        if (jQuery(this).closest(".heading_tabs_wrapper_list").find("#" + tabContent).length > 0) {
            jQuery(this).closest(".heading_tabs_wrapper_list").find("#" + tabContent).addClass("active");
        }
    })

    jQuery(document).on("click", ".tab_content_inner_data_item .tab_content_inner_data_item_inner_toggle", function (e) {
        e.preventDefault();
        var allContent = jQuery(this).parent().parent().find('.tab_content_inner_data_item_inner_content_all');
        if (jQuery(allContent).is(":hidden")) {
            jQuery('.tab_content_inner_data_item_inner_toggle').removeClass("active");
            jQuery('.tab_content_inner_data_item_inner_content_all').slideUp(400);
            jQuery(this).addClass("active");
            jQuery(this).parent().parent().find('.tab_content_inner_data_item_inner_content_all').slideDown();
        } else {
            jQuery('.tab_content_inner_data_item_inner_toggle').removeClass("active");
            jQuery('.tab_content_inner_data_item_inner_content_all').slideUp(400);
        }
    });

    customSelect();

    jQuery(".related_consumables_sec .accordion_access").on("click", function () {
        if (jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").is(":hidden")) {
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_content").slideUp();
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_access").removeClass("active");
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_access").attr("aria-expanded", "false");
            jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideDown();
            jQuery(this).addClass("active");
            jQuery(this).attr("aria-expanded", "true");
        } else {
            jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideUp();
            jQuery(this).removeClass("active");
            jQuery(this).attr("aria-expanded", "false");
        }
    });

    if (jQuery('.product_with_filter_sec').length > 0) {
        jQuery(document).on("click", ".product_with_filter_sec .accordion_access", function () {

            var $this = $(this).parent().parent().parent().parent();
            if ($this.siblings().hasClass("active")) {
                $(".accordion_content").slideUp(400);
                $(".product_list__item").removeClass("active");
                $(".product_list__item__inner__data").removeClass("active");
                $(".accordion_access").removeClass("active");
            }
            $(this).parent().parent().parent().parent().toggleClass("active");
            $(this).parent().parent().toggleClass("active");
            $(this).toggleClass("active");
            $(this).parent().parent().parent().parent().find('.accordion_content').slideToggle(400);


            // if (jQuery(".product_list__item__inner__data").parent().find(".accordion_content").is(":hidden")) {
            //     jQuery(".product_list__item__inner__data").removeClass("active");
            //     jQuery(".product_list__item__inner__data").parent().removeClass("active");
            //     jQuery(".product_with_filter_sec .product_list__item__inner .accordion_content").slideUp();
            //     jQuery(".product_with_filter_sec .product_list__item__inner .accordion_access").removeClass("active");
            //     jQuery(".product_with_filter_sec .product_list__item__inner .accordion_access").attr("aria-expanded", "false");
            //     jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideDown(500);
            //     jQuery(this).addClass("active");
            //     jQuery(this).closest(".product_list__item__inner__data").addClass("active");
            //     jQuery(this).closest(".product_list__item__inner__data").parent().addClass("active");
            //     jQuery(this).attr("aria-expanded", "true");
            // } else {
            //     jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideUp();
            //     jQuery(this).closest(".product_list__item__inner__data").removeClass("active");
            //     jQuery(this).closest(".product_list__item__inner__data").parent().removeClass("active");
            //     jQuery(this).removeClass("active");
            //     jQuery(this).attr("aria-expanded", "false");
            // }
        });
    }


    $(".left_right_heading_content_with_slider").each(function (index) {
        let custom_slider = $(this).find('.left_right_heading_content_with_slider_inner_list_slider');
        let custom_dot_item = $(this).find('.left_right_heading_content_with_slider_dots .left_right_heading_content_with_slider_dots_item');

        $(custom_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            variableWidth: true,
            dots: false,
            speed: 1000,
            cssEase: 'ease',
            customPaging: function (slider, i) {
                return $(custom_dot_item)[i];
            }
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            console.log(nextSlide);
            $(custom_dot_item).removeClass('active');
            $(custom_dot_item).eq(nextSlide).addClass('active');
        });

        $(custom_dot_item).eq(custom_slider.slick('slickCurrentSlide')).addClass('active');

        $(custom_dot_item).on('click', function (event) {
            var slideIndex = $(this).data('slide-index');
            $(custom_slider).slick('slickGoTo', slideIndex);
            event.preventDefault();
        });

    });



    $(".timeline").each(function (index) {
        let timeline_slider = $(this).find('.timeline_inner_list');
        let timeline_slider_nav = $(this).find('.timeline_inner_list_nav');
        let timelineNav_slider = $(this).find('.timeline_nav_list');
        $slick_prev = '<button type="button" class="slick-prev hidden"><svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-1" y="1" width="54.2857" height="54.2857" rx="27.1429" transform="matrix(-1 8.74228e-08 8.74228e-08 1 54.2852 0.714356)" stroke="white" stroke-width="2"/><path d="M30.957 34.4858L25.3285 28.8573L30.957 23.2287" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        $slick_next = '<button type="button" class="slick-next"><svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1.00012" width="54.2857" height="54.2857" rx="27.1429" stroke="white" stroke-width="2"/><path d="M25.3281 33.7716L30.9567 28.143L25.3281 22.5145" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        $(timeline_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            prevArrow: $slick_prev,
            nextArrow: $slick_next,
            appendArrows: timeline_slider_nav,
            dots: false,
            speed: 600,
            fade: true,
            cssEase: 'linear',
        });
        $(timelineNav_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            speed: 600,
            variableWidth: true,
            centerMode: true,
            focusOnSelect: true,
        });

        let timeline_slide_current = timeline_slider.find('.timeline_inner_list_item.slick-slide.slick-current').attr("data-year");
        console.log(timeline_slide_current);
        var navDotDSI = jQuery(".timeline_nav_list .timeline_nav_list_item[data-year='" + timeline_slide_current + "']").attr("data-slick-index");
        if (navDotDSI != undefined && navDotDSI != "" && navDotDSI != null) {
            jQuery(timelineNav_slider).slick("slickGoTo", navDotDSI);
        }

        jQuery(timeline_slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (jQuery(".timeline_inner_list .timeline_inner_list_item[data-slick-index='" + nextSlide + "']").length > 0) {
                var nextYear = jQuery(".timeline_inner_list .timeline_inner_list_item[data-slick-index='" + nextSlide + "']").attr("data-year");
                if (jQuery(".timeline_nav_list .timeline_nav_list_item[data-year='" + nextYear + "']").length > 0) {
                    var navDotDSI = jQuery(".timeline_nav_list .timeline_nav_list_item[data-year='" + nextYear + "']").attr("data-slick-index");
                    if (navDotDSI != undefined && navDotDSI != "" && navDotDSI != null) {
                        jQuery(timelineNav_slider).slick("slickGoTo", navDotDSI);
                    }
                }
            }
        });

        jQuery(document).on("click", ".timeline_nav_list_item.active.slick-slide", function () {
            var index1 = jQuery(this).attr("data-slick-index");
            jQuery(timelineNav_slider).slick("slickGoTo", index1);
        })

        jQuery(timelineNav_slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            if (jQuery(".timeline_nav_list .timeline_nav_list_item[data-slick-index='" + nextSlide + "']").length > 0) {
                var nextYear = jQuery(".timeline_nav_list .timeline_nav_list_item[data-slick-index='" + nextSlide + "']").attr("data-year");
                if (jQuery(".timeline_inner_list .timeline_inner_list_item[data-year='" + nextYear + "']").length > 0) {
                    var navDotDSI = jQuery(".timeline_inner_list .timeline_inner_list_item[data-year='" + nextYear + "']").attr("data-slick-index");
                    if (navDotDSI != undefined && navDotDSI != "" && navDotDSI != null) {
                        jQuery(timeline_slider).slick("slickGoTo", navDotDSI);
                    }
                }
            }
        });
    });

    $("#primary-menu-list > .menu-item-has-children").each(function (index) {
        if (index == 0) {
            $(this).find('.sub-menu-toggle').trigger("click");
        }
    });

    if (jQuery('.team_sec').length > 0) {
        jQuery(".team_sec").each(function (index) {
            jQuery('#tab-1').addClass('current');
            jQuery(document).on('click', '.team_sec__inner .tabs .tab-link', function () {
                var tab_id = jQuery(this).attr('data-tab');

                jQuery('.team_sec__inner .tabs .tab-link').removeClass('current');
                jQuery('.team_sec__inner .tab-content').removeClass('current');

                jQuery(this).addClass('current');
                jQuery("#" + tab_id).addClass('current');
            });
        });
    }

    $(".scroll_to_bottom_section").on("click", function () {
        if ($(this).closest(".hero_banner_sec").parent().next().length > 0) {
            $("body, html").animate({
                scrollTop: $(this).closest(".hero_banner_sec").parent().next().offset().top - 100
            }, 1000);
        }
    });
    $(".scroll_to_bottom_section_hero_slider").on("click", function () {
        if ($(this).closest(".hero_banner_slider_section_wrapper").parent().next().length > 0) {
            $("body, html").animate({
                scrollTop: $(this).closest(".hero_banner_slider_section_wrapper").parent().next().offset().top - 100
            }, 1000);
        }
    });

    // MP4
    $('.video_sec .image.mp4 .play_btn').click(function () {
        $('.video_sec .image.mp4 .video_image').hide();
        $('.video_sec .image.mp4 .play_btn').hide();
        $('.video_sec .image.mp4 .video').show();
        $('.video_sec .image.mp4 .video').find('video').attr("autoplay", "autoplay");
        $('.video_sec .image.mp4 .video').find('video').get(0).play();
    });

    // youTube Video

    $('.video_sec .image.oembed .play_btn').click(function () {
        $('.video_sec .image.oembed .video_image').hide();
        $('.video_sec .image.oembed .play_btn').hide();
        $('.video_sec .image.oembed .video').show();
    });

    $(".video_sec .image.oembed .play_btn").click(function (e) {
        var frame = $(this).parent().parent().find("iframe");
        var videoURL = $(frame).prop('src');
        videoURL += "&autoplay=1";
        $(frame).prop('src', videoURL);
        e.preventDefault();
        $(this).parent().parent().addClass('active');
    });

    $(document).on('click', '.scrolltodiv', function (event) {
        event.preventDefault();
        var target = this.getAttribute('data-target');
        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 1000);
    });


    offsetLeft();

    if (jQuery(".distributor_inner_data_main_nav .next").length > 0) {
        jQuery(".distributor_inner_data_main_nav .next").on("click", function () {
            var current1 = jQuery(this).parent().attr("data-current");
            var last = jQuery(this).parent().attr("data-last");
            var oldCurrent = current1;
            if (current1 == undefined || current1 == "") {
                current1 = 1;
            }
            if (last == undefined || last == "") {
                last = 1;
            }

            if (current1 < last) {
                jQuery(".distributor_inner_data_main_list_item.map_block_" + current1).hide();
                current1++;
                jQuery(".distributor_inner_data_main_list_item.map_block_" + current1).show();
                jQuery(this).parent().attr("data-current", current1);
            }
        })
    }

    if (jQuery(".distributor_inner_data_main_nav .back").length > 0) {
        jQuery(".distributor_inner_data_main_nav .back").on("click", function () {
            var current1 = jQuery(this).parent().attr("data-current");
            var last = jQuery(this).parent().attr("data-last");
            var oldCurrent = current1;
            if (current1 == undefined || current1 == "") {
                current1 = 1;
            }
            if (last == undefined || last == "") {
                last = 1;
            }

            if (current1 > 1) {
                jQuery(".distributor_inner_data_main_list_item.map_block_" + current1).hide();
                current1--;
                jQuery(".distributor_inner_data_main_list_item.map_block_" + current1).show();
                jQuery(this).parent().attr("data-current", current1);
            }
        })
    }

    box_slider_func();
    addClassToHeader();

    var prevScrollpos = jQuery('#masthead').height();
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset,
            siteheader = document.getElementById("masthead"),
            siteheaderHeigjt = siteheader.offsetHeight * 2;
        if (prevScrollpos > currentScrollPos) {
            if (jQuery(".admin-bar").length > 0) {
                siteheader.style.top = "32px";
            } else {
                siteheader.style.top = "0";
            }
        } else {
            if (siteheaderHeigjt < currentScrollPos) {
                siteheader.style.top = "-" + siteheaderHeigjt + "px";
            }
        }
        prevScrollpos = currentScrollPos;
    }

    textureHeight();
});

jQuery(window).on("resize", function () {
    if (jQuery(".left_right_heading_content_with_slider_inner_list_slider").length > 0 && jQuery(".left_right_heading_content_with_slider_inner_list_slider").hasClass("slick-initialized")) {
        setTimeout(function () {
            jQuery(".left_right_heading_content_with_slider_inner_list_slider").slick("refresh");
        }, 200);
    }
    offsetLeft();
    box_slider_func();
    textureHeight();
});


jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    customSelect();
});

jQuery(window).scroll(function () {
    var scrollPosition = jQuery(window).scrollTop();
    var header = jQuery('.site_sticky_header'); // Use your header's ID

    if (scrollPosition > 0) {
        header.addClass('scrolled_header');
    } else {
        header.removeClass('scrolled_header');
    }

    addClassToHeader();
});

function textureHeight() {
    if (jQuery("body #page").length > 0) {
        var textHeight = jQuery("body #page").outerHeight() + 150;
        jQuery("body .top_page_taxture").css("max-height", textHeight);
    }
}

function addClassToHeader() {
    if (jQuery(window).scrollTop() > 100) {
        jQuery(".site_header").addClass("show_bg");
    } else {
        jQuery(".site_header").removeClass("show_bg");
    }
}

function customSelect() {

    jQuery('select:not(.gfield_select)').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    // jQuery('select:not(.gfield_select)').selectric();
    jQuery(document).ready(function () {
        jQuery(document).on("change", ".gfield select", function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        });
        jQuery(".gfield select").each(function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        })
    });
}

function offsetLeft() {
    if ((jQuery('.left_right_heading_content_with_box_slider__inner__list').length > 0)) {
        var applicationsoffset = jQuery('.left_right_heading_content_with_box_slider__inner__list').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.left_right_heading_content_with_box_slider__inner__list').css('width', (applicationswindWidth - applicationsoffset.left));
    }

    if ((jQuery('.left_right_heading_content_with_box_slider__inner__slider_dots').length > 0)) {
        if (jQuery('.left_right_heading_content_with_box_slider__inner__slider_dots').width() < 767) {
            var applicationsoffset = jQuery('.left_right_heading_content_with_box_slider__inner__slider_dots').offset(),
                applicationswindWidth = jQuery(window).width();
            jQuery('.left_right_heading_content_with_box_slider__inner__slider_dots').css('width', (applicationswindWidth - applicationsoffset.left));
        } else {
            jQuery('.left_right_heading_content_with_box_slider__inner__slider_dots').css('width', 'auto');
        }
    }
}

function box_slider_func() {
    // if (jQuery(window).width() < 1200) {
    jQuery(".left_right_heading_content_with_box_slider").each(function (index) {
        let custom_slider = jQuery(this).find('.left_right_heading_content_with_box_slider__inner__list__slider');
        let custom_dot_item = jQuery(this).find('.left_right_heading_content_with_box_slider__inner__slider_dots__inner__item');
        if (!jQuery(this).find('.left_right_heading_content_with_box_slider__inner__list__slider').hasClass("slick-initialized")) {
            jQuery(custom_slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                variableWidth: true,
                dots: false,
                speed: 1000,
                cssEase: 'ease',
                asNavFor: '.left_right_heading_content_with_box_slider__inner__slider_dots__inner'
                // customPaging: function (slider, i) {
                //     return jQuery(custom_dot_item)[i];
                // }
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                console.log(nextSlide);
                // jQuery(custom_dot_item).removeClass('active');
                // jQuery(custom_dot_item).eq(nextSlide).addClass('active');
            });

            // jQuery(custom_dot_item).eq(custom_slider.slick('slickCurrentSlide')).addClass('active');

            jQuery(custom_dot_item).on('click', function (event) {
                var slideIndex = jQuery(this).data('slide-index');
                jQuery(custom_slider).slick('slickGoTo', slideIndex);
                event.preventDefault();
            });
        }
        if (!jQuery(this).find('.left_right_heading_content_with_box_slider__inner__slider_dots__inner').hasClass("slick-initialized")) {
            jQuery(this).find('.left_right_heading_content_with_box_slider__inner__slider_dots__inner').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                variableWidth: true,
                dots: false,
                speed: 1000,
                cssEase: 'ease',
                asNavFor: '.left_right_heading_content_with_box_slider__inner__list__slider'
                // customPaging: function (slider, i) {
                //     return jQuery(custom_dot_item)[i];
                // }
            });
        }
    });
    // } else {
    //     jQuery(".left_right_heading_content_with_box_slider").each(function (index) {
    //         if (jQuery(this).find('.left_right_heading_content_with_box_slider__inner__list__slider').hasClass("slick-initialized")) {
    //             jQuery(this).find('.left_right_heading_content_with_box_slider__inner__list__slider').slick("unslick");
    //         }
    //         if (jQuery(this).find('.left_right_heading_content_with_box_slider__inner__slider_dots__inner').hasClass("slick-initialized")) {
    //             jQuery(this).find('.left_right_heading_content_with_box_slider__inner__slider_dots__inner').slick("unslick");
    //         }
    //     });
    // }
}

// Gravity Forms native hook - fires on load and after any page change/AJAX reload
jQuery(document).on('gform_post_render', function (event, formId, currentPage) {

    // Find the buttons inside the DOM
    const buttons = document.querySelectorAll('.standard_editor_content .enquiry-buttons button');

    buttons.forEach(button => {
        // Remove any existing listener first to prevent duplicate triggers, then add it
        button.removeEventListener('click', handleEnquiryClick);
        button.addEventListener('click', handleEnquiryClick);
    });
});

// Separate named function to handle the click logic cleanly
function handleEnquiryClick(e) {
    e.preventDefault();

    const enquiryValue = this.dataset.enquiry;
    if (!enquiryValue) return;

    // Look for the hidden radio buttons
    const radioButtons = document.querySelectorAll('.enquiry-type-hidden input[type="radio"]');

    radioButtons.forEach(radio => {
        if (radio.value === enquiryValue) {
            radio.checked = true;

            // Trigger change event for Gravity Forms conditional logic
            const changeEvent = new Event('change', { bubbles: true });
            radio.dispatchEvent(changeEvent);
        }
    });
}